// // Filtre

document.addEventListener("DOMContentLoaded", function () {



    var projets = jQuery('#projets');
    if (projets) {
        ajaxProjets();
    }


    jQuery('.cat-list_item').on('click', function() {
        jQuery('.cat-list_item').removeClass('active');
        jQuery(this).addClass('active');
        ajaxProjets(jQuery(this).data('slug'), jQuery(this).data('type'))
    });

    jQuery(".collapse-tri").on("click", () => {
        // if (window.innerWidth <= 991) {
        //     jQuery("#tri-marques").slideUp();
        //     jQuery("#etablissement-list").slideToggle();
        //     jQuery("#categories-list").slideToggle();
            jQuery("#categories-list").slideToggle();
            // jQuery(".collapse-tri").find("svg").toggleClass("rotate");
        // }
    })

});

function ajaxProjets(slug = "", type="projet", page = '1'){
    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_projets',
            category: slug,
            type: type,
            page: page,
        },
        success: function(res) {
            if (res) {

                jQuery('#projets').html(res);
                let catActive =  jQuery('.cat-list_item.active');
                let page = jQuery(".page-numbers").on("click", function (e) {
                    e.preventDefault();
                    ajaxProjets(catActive.data("slug"),'projet',jQuery(this).data("page"));
                    window.location.href = "/les-projets-pepite-france/#liste";
                });
            }
        }
    })
}
